import React, { useRef, useEffect } from "react";
import "./UGTable.scss";
import { DataGrid, GridColDef, gridClasses } from "@mui/x-data-grid";
import { Box, Link, Button, Checkbox } from "@mui/material";

interface Props {
  header_data: Array<any>;
  data: Array<any>;
  value_update: Function;
  attrName: string;
}

const UGTable: React.FC<Props> = ({
  header_data,
  data,
  value_update,
  attrName,
}) => {
  const [columnSortingPopUp, setColumnSortingPopUp] = React.useState(false);
  const [filterCheckboxData, setFilterCheckboxData] =
    React.useState(header_data);
  const [columns, setColumns] = React.useState(() => {
    let data = [];
    for (var i = 0; i < header_data.length; i++) {
      if (header_data[i].check_status == true) {
        data.push(header_data[i]);
      }
    }
    return data;
  });

  // For Hide Filter Pop-Up
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setColumnSortingPopUp(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  //On Click action perform of Checkbox
  const onClickFilterCheckbox = (index: number, value: Boolean) => {
    let filterData = header_data.map((el) =>
      el.headerName === header_data[index].headerName
        ? { ...el, check_status: value }
        : el
    );

    let data = [];
    for (var i = 0; i < filterData.length; i++) {
      if (filterData[i].check_status == true) {
        data.push(filterData[i]);
      }
    }

    setColumns(data);

    setFilterCheckboxData(filterData);
    value_update(attrName, filterData);
  };

  //Hide and show all columns
  const hide_and_show_all_columns = (index: number, status: boolean) => {
    let filterData = header_data.map((el) =>
      el.headerName === header_data[index].headerName
        ? { ...el, check_status: status }
        : { ...el, check_status: status }
    );

    let data = [];
    for (var i = 0; i < filterData.length; i++) {
      if (filterData[i].check_status == true) {
        data.push(filterData[i]);
      }
    }

    setColumns(data);

    setFilterCheckboxData(filterData);
    value_update(attrName, filterData);
  };

  //Filter on Checkbox
  const filter_data = (search: string) => {
    let filteredData = [];

    for (var i = 0; i < header_data.length; i++) {
      if (
        header_data[i].headerName.toLowerCase().includes(search.toLowerCase())
      ) {
        filteredData.push(header_data[i]);
      }
    }

    setFilterCheckboxData(filteredData);
  };

  return (
    <Box className="tableHeight" sx={{ display: "flex", width: "100%" }}>
      <div className="filterBar">
        <Button onClick={() => setColumnSortingPopUp(!columnSortingPopUp)}>
          <span className="bars" />
        </Button>
        {columnSortingPopUp == true ? (
          <div className="showColumns" ref={wrapperRef}>
            <div className="findInput">
              <input
                type="text"
                placeholder="Find column"
                onChange={(e) => {
                  filter_data(e.target.value);
                }}
              />
            </div>

            <div className="rahul">
              {filterCheckboxData.map((item, index) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    size="small"
                    value={item.check_status}
                    onChange={(e) =>
                      onClickFilterCheckbox(index, e.target.checked)
                    }
                    defaultChecked={true}
                  />
                  <p>{item.headerName}</p>
                </div>
              ))}
              {/* <DraggableList width={300} height={34} rowSize={1}>
                {filterCheckboxData.map((item, index) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      size="small"
                      value={item.check_status}
                      onChange={(e) =>
                        onClickFilterCheckbox(index, e.target.checked)
                      }
                      defaultChecked={true}
                    />
                    <p>{item.headerName}</p>
                  </div>
                ))}
              </DraggableList> */}
            </div>
            <div className="hideShowComulns">
              <Link
                onClick={() => {
                  hide_and_show_all_columns(0, false);
                }}
              >
                Hide All
              </Link>
              <Link
                onClick={() => {
                  hide_and_show_all_columns(0, true);
                }}
              >
                Show All
              </Link>
            </div>
          </div>
        ) : null}
      </div>
      <DataGrid
        className="dataList"
        rows={data}
        getRowHeight={() => "auto"}
        sx={{
          [`& .${gridClasses.cell}`]: {
            py: 1,
          },
        }}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        checkboxSelection
      />
    </Box>
  );
};
export default UGTable;
